

export class SOPutConstraint {

  constructor(
    public uid: string,
    public name: string = null,
    public identifier: string = null,
    public description: string = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutConstraint(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'identifier' in params ? params.identifier : null,
      'description' in params ? params.description : null,
    );
  }
}
